import { IQueryDataType } from '@patsnap/synapse_common_interface'
import { IExportDataType, IFieldLangMap } from '@pharmsnap/shared/types'
export const ExportDataTypeLangMap: Partial<IFieldLangMap<IExportDataType>> = {
  dev_status: {
    en: 'Drug R&D Status',
    jp: '医薬品開発段階',
    cn: '药物研发状态',
  },
  drug: {
    en: 'Drug',
    jp: '医薬品',
    cn: '药物',
  },
  patent: {
    en: 'Patent',
    jp: '特許',
    cn: '专利',
  },
  organization: {
    en: 'Organization',
    jp: '機関',
    cn: '机构',
  },
  target: {
    en: 'Target',
    jp: '標的',
    cn: '靶点',
  },
  disease: {
    en: 'Indication',
    jp: '適応症',
    cn: '适应症',
  },
  drug_type: {
    en: 'Drug Type',
    jp: '医薬品タイプ',
    cn: '药物类型',
  },
  clinical_trial: {
    en: 'Clinical Trial',
    jp: '治験',
    cn: '临床试验',
  },
  clinical_trial_result: {
    en: 'Clinical Result',
    jp: '治験結果',
    cn: '临床结果',
  },
  drug_deal: {
    en: 'Deal',
    jp: '医薬品取引',
    cn: '药物交易',
  },
  drug_deal_drug: {
    en: 'Drug',
    jp: '医薬品',
    cn: '药物',
  },
  translational_medicine: {
    en: 'Translational Medicine',
    jp: 'トランスレーショナルリサーチ',
    cn: '转化医学',
  },
  paper: {
    en: 'Literature',
    jp: '文献',
    cn: '文献',
  },
}
export const QueryDataTypeLangMap: Partial<IFieldLangMap<IQueryDataType>> = {
  drug: {
    en: 'Drug',
    jp: '医薬品',
    cn: '药物',
  },
}
